module.exports = __webpack_public_path__ + "static/media/modern-reader-2A.8e1de7f4.png";